import { useTranslation } from 'react-i18next';
import GenericReportMobile from '../ReportsSection/ReportsSectionMobile/_partials/GenericReportMobile';
import SubsCancellationReasonsTableRowHeadingMobile from './SubsCancellationReasonsTableRowHeadingMobile';

export default function SubsCancellationReasonsMobile() {
  const { t } = useTranslation();

  return (
    <GenericReportMobile
      reportType="subsCancellationReasons"
      headingKey="studio.reports.section.subsCancellationReasons.title.mobile"
      descriptionKey="studio.reports.section.subsCancellationReasons.description"
      descriptionTranslationOptions={{
        postProcess: ['reactPostprocessor'],
        learnMoreLink: (
          <a
            className="text-link-level-2-tertiary"
            href={t(
              'studio.reports.section.subsCancellationReasons.description.learnMoreLink.url'
            )}
          >
            {t(
              'studio.reports.section.subsCancellationReasons.description.learnMoreLink.text'
            )}
          </a>
        ),
      }}
      columns={[]}
      RowHeading={SubsCancellationReasonsTableRowHeadingMobile}
      showTotal={false}
      compact={true}
    />
  );
}
